// Allineato a src/styles/_breakpoints.scss: modificare sempre entrambi i file
export const BREAKPOINTS = {
  mobile: 320,
  lowTablet: 481,
  tablet: 768,
  laptop: 1025,
  desktop: 1281,
  wide: 1920,
  ultra: 2560,
};

const below = (px) => `(max-width: ${px - 0.02}px)`;
const above = (px) => `(min-width: ${px}px)`;

export const MQ = {
  phone: below(BREAKPOINTS.lowTablet),    // ≤ 480
  small: below(BREAKPOINTS.tablet),       // ≤ 767
  navDrawer: below(BREAKPOINTS.laptop),   // ≤ 1024: hamburger + drawer
  wide: above(BREAKPOINTS.wide),
  touch: "(pointer: coarse)",
};
